import React, { useState, useEffect } from 'react';
import '../styles/Experience.css';
import LightRays from './LightRays';

const Experience = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [selectedJob, setSelectedJob] = useState(0);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.2 }
    );

    const element = document.getElementById('experience');
    if (element) observer.observe(element);

    return () => observer.disconnect();
  }, []);

  const experiences = [
    {
      company: 'Deepwoods Green Initiatives',
      position: 'AI Automation Engineer Intern',
      duration: '06/2026 – Present',
      location: 'Bengaluru, Karnataka',
      website: 'https://deepwoods.in',
      achievements: [
        'Built an ESG portal to manage and streamline sustainability-related data and workflows',
        'Contributed to an HR automation portal to simplify internal employee and HR processes',
        'Built an internal task management system to improve task assignment, tracking, and team workflows',
        'Currently developing a GRI-based reporting platform to streamline sustainability data collection and reporting workflows'
      ]
    },
    {
      company: 'MCF ISRO',
      position: 'Intern',
      duration: '01/2026 – 05/2026',
      location: 'Hassan, India',
      website: 'https://www.isro.gov.in/mcf.html',
      achievements: [
        'Completed a short term internship focused on gaining ISRO work experience',
        'Developed License Plate Recognition System (LPRS) using Flask, MySQL, and Tesseract OCR',
        'Implemented real-time vehicle monitoring and automated number plate detection',
        'Gained exposure to professional development workflows and industry best practices'
      ]
    }
  ];

  return (
    <div className={`experience-section ${isVisible ? 'visible' : ''}`}>
      <LightRays
        raysOrigin="top-center"
        raysColor="#ffffff"
        raysSpeed={1}
        lightSpread={0.5}
        rayLength={3}
        followMouse={true}
        mouseInfluence={0.1}
        noiseAmount={0}
        distortion={0}
        pulsating={false}
        fadeDistance={1}
        saturation={1}
        className="experience-rays"
      />
      <div className="container">
        <h2 className="section-title">
          <span className="title-number">03.</span>
          Where I've Worked
        </h2>

        <div className="experience-content">
          <div className="job-tabs">
            {experiences.map((job, index) => (
              <button
                key={index}
                className={`tab-button ${selectedJob === index ? 'active' : ''}`}
                onClick={() => setSelectedJob(index)}
              >
                {job.company}
              </button>
            ))}
            <div 
              className="tab-indicator"
              style={{
                '--selected-index': selectedJob,
                '--total-jobs': experiences.length
              }}
            />
          </div>

          <div className="job-details">
            <div className="job-header">
              <h3 className="job-title">
                {experiences[selectedJob].position}
                <span className="job-company">
                  {' '}@ <a 
                    href={experiences[selectedJob].website}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {experiences[selectedJob].company}
                  </a>
                </span>
              </h3>
              <p className="job-duration">
                {experiences[selectedJob].duration}
              </p>
              <p className="job-location">
                📍 {experiences[selectedJob].location}
              </p>
            </div>

            <ul className="job-achievements">
              {experiences[selectedJob].achievements.map((achievement, index) => (
                <li key={index} className="achievement-item">
                  <span className="achievement-arrow">▹</span>
                  {achievement}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Experience;
